function initCollectionListScrollbars() {
  document.querySelectorAll('.collection-list-scrollbar').forEach((track) => {
    const thumb = track.querySelector('.collection-list-scrollbar__thumb');
    const sliderComponent = track.closest('slider-component');
    const slider = sliderComponent && sliderComponent.querySelector('[id^="Slider-"]');
    if (!thumb || !slider) return;

    function update() {
      const scrollWidth = slider.scrollWidth;
      const clientWidth = slider.clientWidth;

      if (scrollWidth <= clientWidth + 1) {
        track.hidden = true;
        return;
      }
      track.hidden = false;

      const trackWidth = track.clientWidth;
      const thumbWidth = Math.max((clientWidth / scrollWidth) * trackWidth, 24);
      const maxScrollLeft = scrollWidth - clientWidth;
      const progress = maxScrollLeft > 0 ? slider.scrollLeft / maxScrollLeft : 0;
      const maxTranslate = trackWidth - thumbWidth;

      thumb.style.width = `${thumbWidth}px`;
      thumb.style.transform = `translateX(${progress * maxTranslate}px)`;
    }

    slider.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(slider);
    update();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionListScrollbars);
} else {
  initCollectionListScrollbars();
}
